import { AntSelectPropsGeneric, AntSelectValue } from 'controls/react/ant/ant-select/types';
import { BaseOptionType } from '@rc-component/select/lib/Select';
import React from 'react';

export function useOnVisibilityChangeToTriggerOnChange<
	VT extends AntSelectValue,
	OptionType extends BaseOptionType,
	P extends Pick<AntSelectPropsGeneric<VT, OptionType>, 'onOpenChange' | 'onChange' | 'value' | 'triggerChangeOnClose'>,
>(props: P) {
	const { onOpenChange, triggerChangeOnClose, value, onChange, ...rest } = props;

	const [tempValue, setTempValue] = React.useState(() => ({
		value: value,
		option: null as OptionType | OptionType[],
	}));

	const openValueRef = React.useRef(false);

	React.useEffect(() => {
		setTempValue({
			value,
			option: null,
		});
	}, [value]);

	const onOpenChangeWrapper = React.useCallback(
		(open: boolean) => {
			openValueRef.current = open;
			props.onOpenChange?.(open);
			if (open == false) {
				onChange(tempValue.value, tempValue.option);
			}
		},
		[onOpenChange, onChange, tempValue],
	);

	const onChangeWrapper = React.useCallback(
		(value: VT, option: OptionType | OptionType[]) => {
			if (!openValueRef.current) {
				onChange(value, option);
			} else {
				setTempValue({
					value,
					option,
				});
			}
		},
		[onChange],
	);

	if (triggerChangeOnClose) {
		return {
			...rest,
			value: tempValue.value,
			onChange: onChangeWrapper,
			onOpenChange: onOpenChangeWrapper,
		};
	} else {
		return {
			...rest,
			value,
			onChange,
			onOpenChange,
		};
	}
}
